"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use_debounce_1 = require("use-debounce");
var useWindowUpdateHelper_1 = __importDefault(require("./useWindowUpdateHelper"));
/**
 * React Hook that returns the current window size and report
 * updates from the 'resize' and 'orientationchange' window event
 *
 * @typedef {WindowSize} WindowSize
 * @param {number} initialSSRWidth Possible setting of width for SSR from device type to prevent CLS
 * @returns {WindowSize} An object containing the window width and height
 */
var useWindowSize = function (initialSSRWidth) {
    if (initialSSRWidth === void 0) { initialSSRWidth = 768; }
    var _a = (0, react_1.useState)(), setWindowSize = _a[1]; // Trigger rerender. Need to do it like this for throttling.
    var windowSize = (0, react_1.useRef)({
        height: 1100,
        width: initialSSRWidth,
    });
    var handleResize = (0, use_debounce_1.useThrottledCallback)(function () {
        windowSize.current = {
            height: window.innerHeight,
            width: window.innerWidth,
        };
        setWindowSize({}); // forces rerender
    }, 200, { trailing: true });
    (0, useWindowUpdateHelper_1.default)(handleResize);
    return windowSize.current;
};
exports.default = useWindowSize;
